<template>
    <div class="opui-item-list">
        <ul class="opui-item-list-is-loading">
            <li v-for="item in items" :key="item">
                <div class="opui-item">
                    <div class="opui-left">
                        <div class="opui-title">
                            <h3>Loading</h3>
                            <div>...</div>
                        </div>
                    </div>

                    <div class="opui-right">
                        <div>
                            <div class="opui-btn">Edit</div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        itemRows: 0,
    },
    computed: {
        items: function () {
            return Array(this.itemRows ? this.itemRows : 10)
        },
    },
}
</script>
